import { FunctionComponent, SVGProps } from 'react';
import Skeleton from '@mui/material/Skeleton';
import cls from './DashboardStats.module.scss';

interface IDashboardStatsItem {
  icon: FunctionComponent<
    SVGProps<SVGSVGElement> & { title?: string | undefined }
  >;
  title: string;
  value: number;
  isLoading: boolean;
}

const DashboardStatsItem = ({
  icon: Icon,
  title,
  value,
  isLoading,
}: IDashboardStatsItem) => {
  return (
    <li className={cls['dashboard-stats-item']}>
      <div className={cls['dashboard-stats-item-icon-wrapper']}>
        <Icon />
        <p className={cls['dashboard-stats-item-title']}>{title}</p>
      </div>
      {isLoading ? (
        <Skeleton width={50} height={40} />
      ) : (
        <p className={cls['dashboard-stats-value']}>{value || 0}</p>
      )}
    </li>
  );
};

export default DashboardStatsItem;
